import { ExtraOptions, RouterModule, Routes, Router } from '@angular/router';
import { NgModule } from '@angular/core';

// import { OktaAuthGuard } from './app.guard';
import { OktaCallbackComponent } from './callback/callback.component';
import {
  OktaAuthGuard,
  // OktaCallbackComponent,
  OktaLoginRedirectComponent,
  OktaAuthService
} from '@okta/okta-angular';
// import { ProtectedComponent } from './protected/protected.component';

export function onAuthRequired(oktaAuth, injector) {
  // Use injector to access any service available within your application
  console.log("INJECTOR")
  const router = injector.get(Router);

  // Redirect the user to your custom login page
  router.navigate(['/']);
}

// import { NotFoundComponent } from './pages/miscellaneous/not-found/not-found.component';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';

const routes: Routes = [
  {
    path: 'implicit/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'login',
    component: OktaLoginRedirectComponent
  },
  { path: 'wpt', loadChildren: 'app/pages/wpt/wpt.module#WptModule' },
  { path: '', loadChildren: 'app/pages/pages.module#PagesModule'},
  { path: '**', redirectTo: '' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
